import React from "react";
import PropTypes from "prop-types";
/* --------------------------------------------- */

const TickIcon = ({ color, ...rest }) => (
  <svg
    width="100%" height="16px"
    viewBox="0 0 16 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M1 7.38598L5.70827 12L17 1"
      stroke={color}
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
);

/* --------------------------------------------- */
TickIcon.propTypes = {
  /** Color of icon. */
  color: PropTypes.string,
  /** Icon css styles. */
  style: PropTypes.object,
};
/* --------------------------------------------- */
TickIcon.defaultProps = {
  color: "transparent",
  style: {
    width: 25,
    height: 25,
  },
};
/* --------------------------------------------- */
export default TickIcon;
/* --------------------------------------------- */
